import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProfilePageService } from '../../services/profile-page.service';
import { Product } from '../../../models/types';
import { CommonModule } from '@angular/common';
import Swal from 'sweetalert2';
import { OrganisationServiceService } from '../../services/organisation-service.service';

@Component({
  selector: 'app-update-product-modal',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CommonModule],
  templateUrl: './update-product-modal.component.html',
  styleUrls: ['./update-product-modal.component.scss']
})
export class UpdateProductModalComponent {
  @Input() product!: Product;
  imageFile: File | undefined;
  imagePreview: string | undefined;

  constructor(
    public activeModal: NgbActiveModal,
    private profilePageService: ProfilePageService,
    private organisationService: OrganisationServiceService
  ) {}

  save() {
    if (this.imageFile) {
      // Handle image file upload if needed
      Swal.fire({
        title: 'Posodabljanje slike...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      this.profilePageService.updateProductWithImage({
        product: this.product,
        picture: this.imageFile
      })
        .subscribe(
          (response) => {
            this.activeModal.close(); // Close the modal after successful update
            window.location.reload(); // Reload the page to see the updated product
          },
          (error) => {
            console.error('Error updating product:', error);
            // Handle error
          }
        );
    } else {
      Swal.fire({
        title: 'Posodabljam...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      this.profilePageService.updateProduct(this.product)
        .subscribe(
          (response) => {
            console.log('Product updated successfully:', response);
            this.activeModal.close(); // Close the modal after successful update
            window.location.reload(); // Reload the page to see the updated product
          },
          (error) => {
            console.error('Error updating product:', error);
            // Handle error
          }
        );
    }
  }

  cancel() {
    this.activeModal.dismiss('cancel');
  }

  onImageUploadChanged(event: Event) {
    const input = event.target as HTMLInputElement;
  
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
  
      if (!allowedTypes.includes(file.type)) {
        // Invalid file type – clear the input
        input.value = '';
        this.imageFile = undefined;
        this.imagePreview = undefined;
        Swal.fire({
          icon: 'warning',
          title: 'Napačen format slike',
          text: 'Podprti formati slik so JPG, JPEG in PNG. Prosimo, poskusite znova.',
        });
        return;
      }
  
      // Valid image file – compress and preview
      this.organisationService.compressImage(file, 70, 70).then((compressedFile) => {
        this.imageFile = compressedFile;
        this.imagePreview = URL.createObjectURL(compressedFile);
      }).catch(error => {
        console.error('Error compressing image:', error);
      });
    }
  }  
  
}
